<template>
  <v-container 
    tag="section"
    fluid
  >
    <validation-observer ref="observer" slim v-slot="{ invalid }">
      <v-row align="center">
        <v-col cols="12">
          <parametros-cmu
            ref="parametrosCmu"
          />
        </v-col>

        <v-col cols="12">
          <v-btn
            id="btn-save-cmu"
            color="success"
            min-width="100"
            style="float: right;"
            :disabled="invalid"
            :loading="loading"
            @click="salvarCmu()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </validation-observer>
  </v-container>
</template>

<script>

import CmuService from "@/services/parametrosComCa/CmuService";

export default {
  name: "EditCmu",

  components: {
    ParametrosCmu: () => import("@/components/parametrosComCa/cmu/ParametrosCmu.vue"),
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },
  },
  
  methods: {
    getFormattedValores(valores) {
      /*
        Formato desejado:
        { 
          $sigla_aneel: { $tipologia: { $ano: custo } }, 
        }

        Exemplo: 
        {
          "CHFUS": {
            "RAR": {
              "2018": "113.55",
              "2019": "149.7"
            },
            "RAU": {
              "2018": "113.55",
              "2019": "149.7"
            }
          },...
        }
      */

      let valoresJson = {};

      valores.forEach(el => {
        if (valoresJson[el.sigla_aneel] == undefined) {
          valoresJson[el.sigla_aneel] = {
            [el.tipologia]: {
              [el.ano]: el.custo
            } 
          };
        } else if (valoresJson[el.sigla_aneel][el.tipologia] == undefined) {
          valoresJson[el.sigla_aneel][el.tipologia] = {
            [el.ano]: el.custo
          };
        } else if (valoresJson[el.sigla_aneel][el.tipologia][el.ano] == undefined) {
          valoresJson[el.sigla_aneel][el.tipologia][el.ano] = el.custo;
        }
      });

      return valoresJson;
    },
    salvarCmu() {
      const id = !this.$route.params.id ? null : this.$route.params.id;
      const ref = this.$refs.parametrosCmu;

      const postData = {
        nome: ref.nome,
        arquivoId: ref.origem == 'arquivo' ? ref.arquivo.id : null,
        nomeArquivo: ref.origem == 'arquivo' ? ref.arquivo.fileObj.name : null,
        delimitador: ref.arquivo.delimitador,
        involucro: ref.arquivo.involucro,
        escape: ref.arquivo.escape,
        parametros: { "siglas_aneel_valores": this.getFormattedValores(ref.valores) },
      };
      
      this.loading = true;
      
      CmuService.salvar(postData, id, this.user.uid)
        .then(() => {
          this.$toast.success('CMU salvo com sucesso.', '', { position:'topRight' })
          this.$router.push({ name: 'CMU' });
        })
        .catch(error => {
          console.error(error);
          if(error.data.error_code == 1001){
            this.$toast.error(error.data.erro, "", { position: "topRight", timeout: 6000 });
          }else{
            this.$toast.error('Erro ao salvar CMU.', '', { position:'topRight' });
          }
          this.$refs.parametrosCmu.arquivo.fileObj = ''
        })
        .finally(() => this.loading = false);
    },
  },
}
</script>

<style>
  .v-alert__icon {
    align-self: center;
  }
</style>